import React, { ReactType, useState, useRef, useEffect } from 'react';
import './styles.scss';
import get from 'lodash/get';


interface IPropType {
  id: string | number
  label: string
  Icons: {
    id: string
    Icon: ReactType
  }[];
  onClick?: any
  active?: boolean
  expository?: boolean
  textStyle?: object
  staticStyle?: boolean;
}

const IconBox = (props: IPropType) => {
  const [boxHeight, setBoxHeight] = useState(80)

  const boxRef = useRef(null)
  
  useEffect(() => {
    setBoxHeight(
      get(boxRef, 'current.clientWidth')
    )
    
  }, [boxRef])

  const handleClick = () => {
    if(props.expository || props.staticStyle){
      return;
    }

    props.onClick(props);
  }

  const containerClassName = (() => {
    let className = 'icon-box';

    if(props.staticStyle){
      className += ' static'
      return className;
    }
    if(props.expository || props.active){
      className += ' expository'
      return className;
    }

    return className;
  })()

  const iconsSize = (() => {
    const size = Math.round(50/props.Icons.length)
    return `${size}%`
  })();
  return (
    <div
      onClick={handleClick}
      key={props.id}
      className={containerClassName}
      style={{ height: boxHeight }}
      ref={boxRef}
    >
      <div className='icon-container'>
        {props.Icons.map(({ Icon, id }) => (
          <Icon 
            key={id} 
            style={{width: iconsSize, height: iconsSize}} 
          />
        ))}
      </div>
      <div className='label-container'>
        <span style={props.textStyle}className="label">{props.label}</span>
      </div>
    </div>
  )
}

export default IconBox
